var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.5 10.8029L4.19593 6.49969L8.5 2.19649L6.65117 0.347656L0.5 6.49969L6.65116 12.6517L8.5 10.8029Z"}));
}

ChevronLeftInline.defaultProps = {"width":"9","height":"13","viewBox":"0 0 9 13"};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
